export default "__VITE_ASSET__8b658870__"